import React from 'react';
import { CopyCard, CopyField, setPageCopySection } from './adminSiteCopyFields';

const CARD_LABELS = ['Call', 'Email', 'Visit', 'WhatsApp'];

export default function AdminSiteContactPageFields({ form, setField }) {
  const contact = form.page_copy?.contact || {};
  const cards = Array.isArray(contact.cards) ? contact.cards : [{}, {}, {}, {}];
  const setContact = (patch) => setPageCopySection(form, setField, 'contact', patch);

  const setCard = (index, patch) => {
    const next = [0, 1, 2, 3].map((i) => ({ ...(cards[i] || {}), ...(i === index ? patch : {}) }));
    setContact({ cards: next });
  };

  return (
    <>
      <CopyCard title="Contact page hero" subtitle="/contact top section">
        <CopyField
          id="contact-eyebrow"
          label="Eyebrow"
          value={contact.eyebrow || ''}
          onChange={(v) => setContact({ eyebrow: v })}
        />
        <CopyField
          id="contact-hero-title"
          label="Page title"
          value={contact.hero_title || ''}
          onChange={(v) => setContact({ hero_title: v })}
        />
        <CopyField
          id="contact-hero-subtitle"
          label="Subtitle"
          value={contact.hero_subtitle || ''}
          onChange={(v) => setContact({ hero_subtitle: v })}
          multiline={2}
        />
        <CopyField
          id="contact-hero-wa"
          label="WhatsApp button label"
          value={contact.hero_whatsapp_button || ''}
          onChange={(v) => setContact({ hero_whatsapp_button: v })}
        />
        <CopyField
          id="contact-hero-shop"
          label="Shop button label"
          value={contact.hero_shop_button || ''}
          onChange={(v) => setContact({ hero_shop_button: v })}
        />
      </CopyCard>

      <CopyCard title="Reach us section" subtitle="Contact method cards">
        <CopyField
          id="contact-reach-title"
          label="Section title"
          value={contact.reach_title || ''}
          onChange={(v) => setContact({ reach_title: v })}
        />
        <CopyField
          id="contact-reach-subtitle"
          label="Section subtitle"
          value={contact.reach_subtitle || ''}
          onChange={(v) => setContact({ reach_subtitle: v })}
        />
        {CARD_LABELS.map((label, i) => (
          <div key={`contact-card-${i}`} className="col-12 border rounded p-3 bg-light">
            <p className="small fw-semibold mb-2">{label} card</p>
            <CopyField
              id={`contact-card-icon-${i}`}
              label="Icon (emoji)"
              value={cards[i]?.icon || ''}
              onChange={(v) => setCard(i, { icon: v })}
            />
            <CopyField
              id={`contact-card-title-${i}`}
              label="Title"
              value={cards[i]?.title || ''}
              onChange={(v) => setCard(i, { title: v })}
            />
            <CopyField
              id={`contact-card-desc-${i}`}
              label="Description"
              value={cards[i]?.desc || ''}
              onChange={(v) => setCard(i, { desc: v })}
              multiline={2}
            />
            {i === 3 ? (
              <CopyField
                id={`contact-card-link-${i}`}
                label="Link label (WhatsApp)"
                value={cards[i]?.link_label || ''}
                onChange={(v) => setCard(i, { link_label: v })}
              />
            ) : null}
          </div>
        ))}
      </CopyCard>

      <CopyCard title="Contact form & hours" subtitle="Form intro and hours heading">
        <CopyField
          id="contact-form-title"
          label="Form title"
          value={contact.form_title || ''}
          onChange={(v) => setContact({ form_title: v })}
        />
        <CopyField
          id="contact-form-subtitle"
          label="Form subtitle"
          value={contact.form_subtitle || ''}
          onChange={(v) => setContact({ form_subtitle: v })}
          multiline={2}
        />
        <CopyField
          id="contact-form-submit"
          label="Submit button label"
          value={contact.form_submit || ''}
          onChange={(v) => setContact({ form_submit: v })}
        />
        <CopyField
          id="contact-hours-title"
          label="Business hours heading"
          value={contact.hours_title || ''}
          onChange={(v) => setContact({ hours_title: v })}
        />
      </CopyCard>
    </>
  );
}
